// src/pages/Home/components/ApplicationEditorialCard.jsx

import React from "react";
import { Link } from "react-router-dom";
import { FaArrowRight, FaExternalLinkAlt } from "react-icons/fa";

const isExternalUrl = (url = "") => /^https?:\/\//i.test(url);

function ApplicationLink({ app, children, className }) {
  if (app.to === "#contact") {
    return (
      <a href={app.to} className={className}>
        {children}
      </a>
    );
  }

  if (app.external || isExternalUrl(app.to)) {
    return (
      <a
        href={app.to}
        target="_blank"
        rel="noopener noreferrer"
        className={className}
      >
        {children}
      </a>
    );
  }

  return (
    <Link to={app.to} className={className}>
      {children}
    </Link>
  );
}

export default function ApplicationEditorialCard({
  app,
  priority = false,
}) {
  const Icon = app.icon;

  return (
    <article className="group min-w-0">
      <ApplicationLink app={app} className="block">
        <div className="relative aspect-[4/3] overflow-hidden rounded-[18px] bg-slate-100 dark:bg-slate-900">
          <img
            src={app.image}
            alt={`Présentation de ${app.name}`}
            loading={priority ? "eager" : "lazy"}
            className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.035]"
          />

          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/55 via-transparent to-transparent opacity-70 transition-opacity duration-300 group-hover:opacity-90" />

          <div className="absolute left-4 top-4">
            <span className="inline-flex items-center gap-2 rounded-full bg-white/92 px-3 py-2 text-[10px] font-semibold uppercase tracking-[0.14em] text-slate-800 shadow-sm backdrop-blur-md">
              {Icon ? <Icon className="text-[#0868f2]" /> : null}
              {app.target}
            </span>
          </div>

          {app.external || isExternalUrl(app.to) ? (
            <span className="absolute right-4 top-4 grid h-9 w-9 place-items-center rounded-full bg-slate-950/50 text-white backdrop-blur-md">
              <FaExternalLinkAlt className="text-[10px]" />
            </span>
          ) : null}

          <div className="absolute bottom-4 right-4">
            <span className="grid h-11 w-11 translate-y-2 place-items-center rounded-full bg-white text-[#0868f2] opacity-0 shadow-lg transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
              <FaArrowRight className="text-xs" />
            </span>
          </div>
        </div>

        <div className="pt-5">
          <div className="flex items-start justify-between gap-4">
            <div className="min-w-0">
              <p className="text-[11px] font-semibold uppercase tracking-[0.17em] text-[#ff7900]">
                {app.target}
              </p>

              <h3 className="mt-2 text-2xl font-semibold tracking-[-0.025em] text-slate-950 transition-colors group-hover:text-[#0868f2] dark:text-white dark:group-hover:text-blue-300">
                {app.name}
              </h3>
            </div>

            <FaArrowRight className="mt-2 shrink-0 text-xs text-slate-300 transition-all duration-300 group-hover:translate-x-1 group-hover:text-[#ff7900] dark:text-slate-600" />
          </div>

          <p className="mt-2 text-base font-medium leading-6 text-slate-800 dark:text-slate-200">
            {app.headline}
          </p>

          <p className="mt-2 line-clamp-2 text-sm leading-6 text-slate-500 dark:text-slate-400">
            {app.short}
          </p>
        </div>
      </ApplicationLink>
    </article>
  );
}